import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import Components from '../core/Components';
import UserPreferencesHandler from '../lib/UserPreferencesHandler';

import { loadGsapDraggable } from '../lib/async-bundles';

export default (el, props) => {

    const LARGE_ELEMENT_SIZE_BIG = 36;
    const LARGE_ELEMENT_SIZE_SMALL = 68;
    const MEDIUM_ELEMENT_SIZE_BIG = 24;
    const MEDIUM_ELEMENT_SIZE_SMALL = 50;
    const SMALL_ELEMENT_SIZE_BIG = 16;
    const SMALL_ELEMENT_SIZE_SMALL = 50;

    const $el = $(el);
    const $slideWrapper = $el.find('[data-slide-wrapper]');
    const $dragWrapper = $el.find('[data-drag-wrapper]');
    const $textWrapper = $el.find('[data-text-wrapper]');

    let gsap = null;
    let Draggable = null;
    let InertiaPlugin = null;

    let isBigly = Viewport.breakpoint.size >= 1200;
    let slides = [];
    let originalSlidesNum = 0;
    let currentIndex = 0;
    let timeline = null;
    let loop = null;
    let timeoutInt = null;
    let interactTimeout = null;
    let autoplayInterval = null;
    let mouseDownTime = 0;
    let mouseDownX = 0;
    let lastW = Viewport.width;

    const init = () => {
        if (UserPreferencesHandler.shouldAnimate()) {
            loadGsapDraggable(({ default: loadedData }) => {
                gsap = loadedData.gsap;
                Draggable = loadedData.Draggable;
                InertiaPlugin = loadedData.InertiaPlugin;
                // gsap.defaults({ overwrite: 'auto' });

                initSlideshow();

                $dragWrapper.on('pointerdown', onSlideshowDown);
                $dragWrapper.on('pointerup', onSlideshowUp);
                Viewport.on('resize', onResize);
            });
        }
    };

    const destroy = () => {
        Viewport.off('resize', onResize);
    };

    const onResize = () => {
        if (lastW !== Viewport.width) {
            isBigly = Viewport.breakpoint.size >= 1200;

            clearTimeout(timeoutInt);

            timeoutInt = setTimeout(() => {
                destroySlideshow();
                initSlideshow();
            }, 100);
            
            lastW = Viewport.width;
        }
    };

    const onSlideshowDown = e => {
        didInteract();
        mouseDownTime = (new Date()).getTime();
        mouseDownX = e.clientX;
    };

    const onSlideshowUp = e => {
        didInteract();
        const upTime = (new Date()).getTime();
        const x = e.clientX;

        if (upTime - mouseDownTime < 250 && Math.abs(mouseDownX - x) < (isBigly ? 100 : 50)) {
            const clickAction = getClickAction(x);

            console.log('click action is ' + clickAction);

            if (clickAction === 'next') {
                hideText();
                loop.next({ duration: 0.7, ease: 'quint.out' });
            } else if (clickAction === 'prev') {
                hideText();
                loop.previous({ duration: 0.7, ease: 'quint.out' });
            } else {
                const { slideEl } = slides[currentIndex];
                const $link = $(slideEl).find('a');

                if ($link.length > 0) {
                    $link.get(0).click();
                }
            }
        }

        mouseDownTime = 0;
    };
    
    const initSlideshow = () => {
        const $slides = $el.find('[data-slide]');

        $slideWrapper.css({ height: $slideWrapper.height() });

        $slides.each(slideEl => {
            slides.push({ slideEl, isOriginal: true });
        });

        originalSlidesNum = slides.length;

        if (slides.length < 7) { // 5 + one on each side
            const duplicateSlidesNum = Math.ceil(7 / slides.length) - 1;
            const originalSlidesLength = slides.length;

            for (let j = 0; j < duplicateSlidesNum; j += 1) {
                for (let i = 0; i < originalSlidesLength; i += 1) {
                    const duplicateSlide = slides[i];
                    const duplicatedEl = duplicateSlide.slideEl.cloneNode(true);
                    $slideWrapper.append(duplicatedEl);
                    slides.push({ slideEl: duplicatedEl, isOriginal: false });
                    
                    $(duplicatedEl).find('[data-component-booted]').attr('data-component-booted', null);
                    
                }
            }
        }
        
        $slideWrapper.find('[data-lazy-component]').each(el => {
            $(el).attr('data-component', $(el).attr('data-lazy-component'));
        });
        
        Components.init($slideWrapper);
        
        timeline = gsap.timeline({ paused: true, loop: true });

        // set initial widths and positions
        slides.forEach((slidedef, index) => {
            const { slideEl } = slidedef;

            const slideWidth = getSlideWidth(slides.length, index, 0);
            const slidePos = getSlidePos(slides.length, index, 0);
            timeline.set(slideEl, { position: 'absolute', width: slideWidth + '%', left: slidePos + '%', scale: 1.001, transformOrigin: 'top' });
        });

        // Add all slide positions to the timeline
        for (let i = 0; i < slides.length; i += 1) {
            let lastPos = 0;
            for (let j = 1; j < slides.length + 1; j += 1) { // this is the offset on the timeline
                const slidedef = slides[i];
                const { slideEl } = slidedef;

                const slideWidth = getSlideWidth(slides.length, i, j);
                const slidePos = getSlidePos(slides.length, i, j);
                timeline.to(slideEl, { duration: (Math.abs(lastPos - slidePos) >= 100) ? 0 : 1, width: slideWidth + '%', left: slidePos + '%', ease: 'none' }, j - 1);

                lastPos = slidePos;
            }
        }

        timeline.progress(1, true).progress(0, true); // prerender

        createDraggable();
        createAutoplay();

        /*
        gsap.to(timeline, { duration: 2, delay: 2, progress: (1 / slides.length) * 5, ease: 'quint.inOut' });
        gsap.to(timeline, { duration: 2, delay: 5, progress: (1 / slides.length) * 3, ease: 'quint.inOut' });
        */
    };

    const createAutoplay = () => {
        if (timeline) {
            autoplayInterval = setInterval(() => {
                hideText();
                loop.next({ duration: 0.7, ease: 'quint.out' });
            }, 4000);
        }
    };

    const stopAutoplay = () => {
        clearInterval(autoplayInterval);
    };
    
    const didInteract = () => {
        clearTimeout(interactTimeout);
        stopAutoplay();
        
        interactTimeout = setTimeout(() => {
            createAutoplay();
        }, 4000);
    };

    const destroySlideshow = () => {
        clearTimeout(interactTimeout);
        stopAutoplay();

        $slideWrapper.css({ height: '' });

        slides.forEach((slidedef, index) => {
            const { slideEl, isOriginal } = slidedef;

            if (isOriginal) {
                gsap.set(slideEl, { position: '', width: '', left: '', scale: '', transformOrigin: 'top' });
            } else {
                slideEl.remove();
            }
        });

        timeline.kill();
        loop.draggable.kill();
        loop.kill();

        slides = [];
    };

    const createDraggable = () => {
        $dragWrapper.empty();
        $dragWrapper.css({ height: $slideWrapper.height() + $textWrapper.height() });

        const items = [];

        for (let i = 0; i < slides.length; i += 1) {
            const $item = $('<div class="flex-none relative w-36 h-full" data-item-num="' + i + '"></div>');
            $dragWrapper.append($item);
            items.push($item.get(0));
        }

        /*
        const colors = ['#0ae44855', '#9d95ff55', '#abff8455', '#00bae255'];
        gsap.set(items, { backgroundColor: gsap.utils.wrap(colors) });
        */

        let activeElement = null;

        loop = horizontalLoop(items, {
            paused: true,
            draggable: true, // make it draggable
            center: true,
            onUpdate: (progress) => {
                gsap.set(timeline, { progress: progress, ease: 'none' });
            },
        });

        //items.forEach((item, i) => item.addEventListener('click', () => loop.toIndex(i, {duration: 0.8, ease: 'power1.inOut'})));
    };

    // HELPER FUNCTION TO SELECT MIDDLE ITEM
    const setActive = (mid) => {
        //console.log('setActive');
        currentIndex = mid % originalSlidesNum;
        updateText();
    };

    const updateText = () => {
        const $texts = $($textWrapper.get(0).children);
        $texts.removeClass('active');
        $texts.eq(currentIndex).addClass('active');
    };

    const hideText = () => {
        const $texts = $($textWrapper.get(0).children);
        $texts.removeClass('active');
    };

    /*
    This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.
    
    Features:
     - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
     - When each item animates to the left or right enough, it will loop back to the other side
     - Optionally pass in a config object with values like draggable: true, speed (default: 1, which travels at roughly 100 pixels per second), paused (boolean), repeat, reversed, and paddingRight.
     - The returned timeline will have the following methods added to it:
       - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
       - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
       - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
       - current() - returns the current index (if an animation is in-progress, it reflects the final index)
       - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
       
       See:
       https://codepen.io/Nick_Ls/penx/mdXxLXJ
       https://codepen.io/GreenSock/pen/gOvvJee
       https://gsap.com/community/forums/topic/32443-draggable-infinite-carousel-with-snap-and-indexing/
     */
    function horizontalLoop(items, config) {
        items = gsap.utils.toArray(items);
        config = config || {};
        const onUpdate = config.onUpdate;
        let tl = gsap.timeline({
                repeat: config.repeat,
                paused: config.paused,
                defaults: { ease: 'none' },
                onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
                onUpdate: () => {
                    if (onUpdate) {
                        onUpdate(tl.progress());
                    }
                }
            }),
            length = items.length,
            startX = items[0].offsetLeft,
            times = [],
            widths = [],
            xPercents = [],
            curIndex = 0,
            pixelsPerSecond = (config.speed || 1) * 100,
            snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
            populateWidths = () => items.forEach((el, i) => {
                widths[i] = Math.round(parseFloat(gsap.getProperty(el, "width", "px")));
                xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / widths[i] * 100 + gsap.getProperty(el, 'xPercent'));
            }),
            getTotalWidth = () => items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') + (parseFloat(config.paddingRight) || 0),
            totalWidth,
            curX,
            distanceToStart,
            distanceToLoop,
            item,
            i;

        populateWidths();

        gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
            xPercent: i => xPercents[i]
        });

        gsap.set(items, { x: 0 });
        totalWidth = getTotalWidth();

        for (i = 0; i < length; i++) {
            item = items[i];
            curX = xPercents[i] / 100 * widths[i];
            distanceToStart = item.offsetLeft + curX - startX;
            distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
            tl.to(item, { xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond }, 0)
                .fromTo(item, { xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100) }, { xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false }, distanceToLoop / pixelsPerSecond)
                .add("label" + i, distanceToStart / pixelsPerSecond);
            times[i] = distanceToStart / pixelsPerSecond;
        }

        function toIndex(inIndex, vars) {
            vars = vars || {};
            (Math.abs(inIndex - curIndex) > length / 2) && (inIndex += (inIndex > curIndex ? -length : length)); // always go in the shortest direction
            let newIndex = gsap.utils.wrap(0, length, inIndex),
                time = times[newIndex];
            if (time > tl.time() !== inIndex > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
                vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
                time += tl.duration() * (inIndex > curIndex ? 1 : -1);
            }

            curIndex = newIndex;
            vars.overwrite = true;

            // Necessary to update the final index after we're done animating
            vars.onComplete = () => {
                tl.updateIndex();
                setActive(tl.current());
            };

            return tl.tweenTo(time, vars);
        }

        tl.next = vars => {
            toIndex(curIndex + 1, vars);
        };
        tl.previous = vars => {
            toIndex(curIndex - 1, vars);
        };
        tl.current = () => curIndex;
        tl.toIndex = (index, vars) => toIndex(index, vars);
        tl.updateIndex = () => {
            curIndex = Math.round(tl.progress() * items.length);
        };
        tl.times = times;

        tl.progress(1, true).progress(0, true); // pre-render for performance

        if (config.reversed) {
            tl.vars.onReverseComplete();
            tl.reverse();
        }

        if (config.draggable && typeof (Draggable) === 'function') {
            let proxy = document.createElement('div'),
                wrap = gsap.utils.wrap(0, 1),
                ratio,
                startProgress,
                draggable,
                dragSnap,
                roundFactor,
                align = () => {
                    tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio));
                },
                syncIndex = () => tl.updateIndex();

            typeof (InertiaPlugin) === 'undefined' && console.warn('InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club');

            draggable = Draggable.create(proxy, {
                trigger: items[0].parentNode,
                type: 'x',
                onPress() {
                    startProgress = tl.progress();
                    tl.progress(0);
                    populateWidths();
                    totalWidth = getTotalWidth();
                    ratio = 1 / totalWidth;
                    dragSnap = totalWidth / items.length;
                    roundFactor = Math.pow(10, ((dragSnap + '').split('.')[1] || '').length);
                    tl.progress(startProgress);
                },
                onDrag: () => {
                    align();
                    didInteract();
                },
                onDragStart: () => {
                    hideText();
                },
                onThrowUpdate: align,
                inertia: true,
                resistance: 0.75,
                edgeResistance: 0.85,
                // The throw animation won't be longer than 0.4 seconds
                maxDuration: 0.4,
                snap: value => {
                    let n = Math.round(parseFloat(value) / dragSnap) * dragSnap * roundFactor;
                    return (n - n % 1) / roundFactor;
                },
                onRelease: () => {
                    syncIndex();
                    didInteract();
                },
                onThrowComplete: () => {
                    // Find the middle item and toggle Class
                    gsap.set(proxy, { x: 0 });
                    syncIndex();
                    setActive(tl.current());
                }
            })[0];

            tl.draggable = draggable;
        }

        return tl;
    }

    const getSlideWidth = (length, index, offset) => {
        offset %= length;

        if (index === offset) {
            return isBigly ? LARGE_ELEMENT_SIZE_BIG : LARGE_ELEMENT_SIZE_SMALL;
        }

        const isOneOff = Math.abs(index - offset) === 1 || Math.abs(index - offset) === length - 1;

        if (isOneOff) {
            return isBigly ? MEDIUM_ELEMENT_SIZE_BIG : MEDIUM_ELEMENT_SIZE_SMALL;
        }

        return isBigly ? SMALL_ELEMENT_SIZE_BIG : SMALL_ELEMENT_SIZE_SMALL;
    };

    const getSlidePos = (length, index, offset) => {
        offset %= length;

        const centerOffset = (100 - (isBigly ? LARGE_ELEMENT_SIZE_BIG : LARGE_ELEMENT_SIZE_SMALL)) / 2; // what's left divided by 2

        if (index === offset) {
            return centerOffset;
        }

        let relativeIndex = index - offset;

        // Ensure we stay within bounds by wrapping around
        if (relativeIndex < -(length / 2)) {
            relativeIndex += length;
        } else if (relativeIndex > length / 2) {
            relativeIndex -= length;
        }

        let offsetSum = 0;

        if (relativeIndex > 0) {
            offsetSum = isBigly ? LARGE_ELEMENT_SIZE_BIG : LARGE_ELEMENT_SIZE_SMALL;

            if (Math.abs(relativeIndex) > 1) {
                offsetSum += isBigly ? MEDIUM_ELEMENT_SIZE_BIG : MEDIUM_ELEMENT_SIZE_SMALL;
            }

            if (Math.abs(relativeIndex) > 2) {
                offsetSum += (isBigly ? SMALL_ELEMENT_SIZE_BIG : SMALL_ELEMENT_SIZE_SMALL) * (Math.abs(relativeIndex) - 2);
            }
        } else {
            offsetSum = isBigly ? MEDIUM_ELEMENT_SIZE_BIG : MEDIUM_ELEMENT_SIZE_SMALL;

            if (Math.abs(relativeIndex) > 1) {
                offsetSum += (isBigly ? SMALL_ELEMENT_SIZE_BIG : SMALL_ELEMENT_SIZE_SMALL) * (Math.abs(relativeIndex) - 1);
            }
        }

        return centerOffset + ((relativeIndex > 0 ? 1 : -1) * offsetSum);
    };

    const getClickAction = coordX => {
        const vw = Viewport.width;
        const centerAreaWidth = vw * ((isBigly ? LARGE_ELEMENT_SIZE_BIG : LARGE_ELEMENT_SIZE_SMALL) / 100);
        const sideAreaWidth = (vw - centerAreaWidth) / 2;

        if (coordX < sideAreaWidth) {
            return 'prev';
        }
        if (coordX > vw - sideAreaWidth) {
            return 'next';
        }

        return 'click';
    };

    return {
        init,
        destroy
    };
};
